import { GetTermsOfServiceResponse } from 'rpc/model/squareup/buyerportal/merchantportal/loyalty/data';
import { LoyaltyTermsOfService } from 'rpc/model/squareup/card/balance/model/loyalty-terms-of-service';

export class LoyaltyTermsOfServiceState {
  static fromProto(
    proto: GetTermsOfServiceResponse
  ): LoyaltyTermsOfServiceState {
    return new LoyaltyTermsOfServiceState()
      .setAvailableNewTos(proto.availableNewTos)
      .setLatestAcceptedTos(proto.latestAcceptedTos);
  }

  availableNewTos?: LoyaltyTermsOfService;
  latestAcceptedTos?: LoyaltyTermsOfService;

  setAvailableNewTos(tos?: LoyaltyTermsOfService) {
    this.availableNewTos = tos ?? undefined;
    return this;
  }

  setLatestAcceptedTos(tos?: LoyaltyTermsOfService) {
    this.latestAcceptedTos = tos ?? undefined;
    return this;
  }
}
